export default {
    currEnv: 'uat3'
}